module.exports = __webpack_public_path__ + "static/img/bosum-logo.c718823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bosum-logo.png
// module id = wUdB
// module chunks = 1